import { render } from "./GradientBox.vue?vue&type=template&id=6389e53c&scoped=true"
import script from "./GradientBox.vue?vue&type=script&lang=js"
export * from "./GradientBox.vue?vue&type=script&lang=js"

import "./GradientBox.vue?vue&type=style&index=0&id=6389e53c&lang=scss"
import "./GradientBox.vue?vue&type=style&index=1&id=6389e53c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6389e53c"]])

export default __exports__